import React from 'react';
import SkuList from '../../../components/Dashboard/SkuList';
import SkuList2 from '../../../components/Dashboard/SkuList2';
import './style.scss';

const SkuListPage = () =>{
    return(
        <div className='sku_list_page'>
            {/* <SkuList/> */}
            <SkuList2/>
        </div>
    )
}

export default SkuListPage;